import { Vue, Options } from 'vue-class-component';
import { CallingCodeDTO } from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'CodeRecap',
  components: {
  },
  props: {
    recapCode: {
      required: true,
      type: Object as () => CallingCodeDTO,
    },
  },
  watch: {},
  emits: [],
  computed: {},
})
export default class CodeRecap extends Vue {
  recapCode!: CallingCodeDTO;
}
